<template>
  <div class="visitor-over-view">
    <div class="visitor-over-view-line" style="margin: 40px 0;padding: 0 40px;">
      <div class="visitor-person-count-box" style="background:linear-gradient(#12C9E4, #12C9E499);margin-right:20px">
        <i class="el-icon-damai-ic_jinchangluru"></i>
        <div class="visitor-person-count-box-info">
          <div class="visitor-person-count">{{enter}}</div>
          <div class="visitor-person-tip">报警点数量</div>
        </div>
      </div>
      <div class="visitor-person-count-box" style="background:linear-gradient(#ED7D31, #ED7D3199);margin-right:20px">
        <i class="el-icon-damai-ic_chuchangjiaozheng1"></i>
        <div class="visitor-person-count-box-info">
          <div class="visitor-person-count">{{out}}</div>
          <div class="visitor-person-tip">当日报警数</div>
        </div>
      </div>
      <div class="visitor-person-count-box" style="background:linear-gradient(#ED7D31, #ED7D3199);margin-right:20px">
        <i class="el-icon-damai-ic_chuchangjiaozheng1"></i>
        <div class="visitor-person-count-box-info">
          <div class="visitor-person-count">{{out}}</div>
          <div class="visitor-person-tip">当日报警解除数</div>
        </div>
      </div>
      <div class="visitor-person-count-box" style="background:linear-gradient(#ED7D31, #ED7D3199);margin-right:20px">
        <i class="el-icon-damai-ic_chuchangjiaozheng1"></i>
        <div class="visitor-person-count-box-info">
          <div class="visitor-person-count">{{out}}</div>
          <div class="visitor-person-tip">当日报警报警中</div>
        </div>
      </div>
<!--      <div class="visitor-person-count-box" style="background:linear-gradient(#92D050, #92D05099);">-->
<!--        &lt;!&ndash; <i class="el-icon-damai-dengji"></i> &ndash;&gt;-->
<!--        <div class="visitor-person-count-box-info">-->
<!--          <div class="visitor-person-count" style="text-align:center">{{deviceCount}}</div>-->
<!--          <div class="visitor-person-tip" style="text-align:center">设备总数</div>-->
<!--        </div>-->
<!--        <div class="visitor-person-count-box-info">-->
<!--          <div class="visitor-person-count" style="text-align:center">{{offlineCount}}</div>-->
<!--          <div class="visitor-person-tip" style="text-align:center">离线设备数</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div class="finance-over-view-line" style="height: 280px;margin: 120px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">
      <chart-time-select @getData="getStatisticsByType" />
      <common-line style="z-index: 1000" lineId='customerFlowStatisticsLine' :height='"260px"' lineTitle='流量统计' :legendData="parkingTrafficStatisticsLegendData" :xAxis="parkingTrafficStatisticsXAxis" :yAxis='parkingTrafficStatisticsYAxis' :series='parkingTrafficStatisticsSeries' />
    </div>
  </div>
</template>

<script>
import CommonLine from "../../../components/Echarts/Line/commonLine";
import { api } from "../../api/CustomerFlow";
import { errorHandler } from "../../../utils/errorHandler";
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";

export default {
  components: { ChartTimeSelect, CommonLine },
  name: "video-alarm-over-view",
  data() {
    return {
      deviceCount: 0,
      offlineCount: 0,
      enter: 0,
      out: 0,

      parkingTrafficStatisticsLegendData: ["进客流量", "出客流量"],
      parkingTrafficStatisticsXAxis: {
        type: "category",
        name: "日期",
        data: []
      },
      parkingTrafficStatisticsYAxis: [
        {
          type: "value",
          name: "人",
          splitLine: {
            show: false
          }
        }
      ],
      parkingTrafficStatisticsSeries: []
    };
  },
  mounted() {
    this.getOverview();
  },
  methods: {
    getOverview() {
      this.$axios
        .get(api.getOverview, {})
        .then(res => {
          let data = res.data.data;
          this.deviceCount = data.deviceCount;
          this.offlineCount = data.offlineCount;
          this.enter = data.enter;
          this.out = data.out;
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 流量统计
    getStatisticsByType(type, startTime, endTime) {
      this.$axios
        .post(`${api.getStatisticsByType}`, {
          timeType: type || "DAY",
          startTime: startTime,
          endTime: endTime
        })
        .then(res => {
          let data = res.data.data;
          let xData = [],
            carInNumberSeriesData = [],
            carOutNumberSeriesData = [];
          data.map(v => {
            carInNumberSeriesData.push(v.enter.toString());
            carOutNumberSeriesData.push(v.out.toString());

            if (v.timeType == "HOUR") {
              v.time = v.time.slice(11, 16);
            }
            xData.push(v.time);
          });
          this.parkingTrafficStatisticsXAxis.data = xData;
          this.parkingTrafficStatisticsSeries = [
            {
              name: "进客流量",
              type: "line",
              stack: "进客流量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#00A0E6"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00A0E6"
                  },
                  {
                    offset: 1,
                    color: "#ffe"
                  }
                ])
              },
              data: carInNumberSeriesData
            },
            {
              name: "出客流量",
              type: "line",
              stack: "出客流量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#4BB66E"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#4BB66E"
                  },
                  {
                    offset: 1,
                    color: "#ffe"
                  }
                ])
              },
              data: carOutNumberSeriesData
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    }
  }
};
</script>

<style lang="less">
.visitor-over-view {
  padding: 10px 2%;
  .visitor-over-view-line {
    display: flex;
    justify-content: space-between;
    .visitor-person-count-box {
      width: 30%;
      height: 160px;
      padding: 10px 10px;
      border-radius: 10px;
      color: #ffffff;
      background-color: #00a0e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      i {
        width: 30%;
        font-size: 48px;
      }
      .visitor-person-count-box-info {
        width: 70%;
        text-align: left;
        .visitor-person-count {
          font-size: 36px;
          font-weight: 600;
          word-wrap: break-word;
        }
        .visitor-person-tip {
          font-size: 16px;
        }
      }
    }
    .visitor-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
    }
    .visitor-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      overflow: hidden;
    }

    .el-table {
      thead {
        th {
          padding: 6px 0;
          text-align: center;
          color: #666666;
          background-color: #eff1f5;
        }
      }
      tbody {
        td {
          padding: 6px 0;
          text-align: center;
          color: #ff0000;
        }
      }
    }

    .el-pagination {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/VideoAlarm/OverView/OverView.vue